<div class="info-item info-eco">
  <img [src]="assets.avlInfoImg1" class="text-img eng_only" alt="We care environment" />
  <img
    [src]="assets.selectVehicleInfoArabicImg1"
    class="text-img ar_only"
    alt="We care environment" />
  <img [src]="assets.selectVehicleInfoMlImg1" class="text-img ml_only" alt="We care environment" />
</div>
<div class="info-item info-search">
  <img [src]="assets.avlInfoImg2" class="text-img eng_only" alt="Search your options" />
  <img
    [src]="assets.selectVehicleInfoArabicImg2"
    class="text-img ar_only"
    alt="Search your options" />
  <img [src]="assets.selectVehicleInfoMlImg2" class="text-img ml_only" alt="Search your options" />
</div>
<div class="info-item info-choose">
  <img [src]="assets.avlInfoImg3" class="text-img eng_only" alt="Choose enter details" />
  <img
    [src]="assets.selectVehicleInfoArabicImg3"
    class="text-img ar_only"
    alt="Choose enter details" />
  <img [src]="assets.selectVehicleInfoMlImg3" class="text-img ml_only" alt="Choose enter details" />
</div>
